export function parseConcessions(listing, actor) {
  let amount = +listing[actor + '_concession_amount']
    , unit = listing[actor + '_concession_unit']
    , closePrice = +listing.close_price
    , concessions = {};

  if (amount && unit && closePrice) {
    let formattedAmountField = actor + '_concession_amount_cents'
      , formattedAmountPercentage = actor + '_concession_percentage';

    if (unit === '$') {
      concessions[formattedAmountField] = amount * 100;
      concessions[formattedAmountPercentage] = amount / closePrice;
    } else if (unit === '%') {
      concessions[formattedAmountField] = amount * closePrice;
      concessions[formattedAmountPercentage] = amount;
    }
  }

  return concessions;
}

export function parseNetConcessionAmountCents(listing) {
  let sellerConcessions = parseConcessions(listing, 'seller')
    , buyerConcessions = parseConcessions(listing, 'buyer');
  return (sellerConcessions.seller_concession_amount_cents || 0) -
    (buyerConcessions.buyer_concession_amount_cents || 0);
}



/** WEBPACK FOOTER **
 ** ./javascripts/common/helpers/parse-listing-concession.js
 **/